// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#group-page .group-page__header {
    text-align: center;
}
#group-page .group-page__header .group-image {
    display: block;
    margin: 0 auto 20px auto;
    max-width: 200px;
    height: 200px;
}
#group-page .group-page__header .title {
    font-size: 2em;
    margin: 0.5em auto;
}
#group-page .group-page__header .types {
    font-size: 1.2em;
    color: var(--primary-color-dark);
    margin: 0.5em auto;
}
#group-page .group-page__header .types span {
    display: inline-block;
    margin: 0 5px;
}
#group-page .group-page__header .types svg {
    width: 1.2em;
    height: 1.2em;
    margin-bottom: -0.2em;
}

#group-page .details {
    font-size: 16px;
    max-width: 400px;
    margin: 0 auto;
    text-align: center;
}
#group-page .details .about {
    font-size: 14px;
    padding: 12px;
    white-space: pre-line;
    word-wrap: break-word;
    text-align: left;
}

#group-page .group-page__controls {
    text-align: center; 
    margin: 20px auto;
}

#group-page .group-page__private {
    margin: 50px auto;
    text-align: center;
    font-size: 20px;
}

#group-page .group-page__main {
    box-sizing: border-box;
    padding: 1px; 
}

`, "",{"version":3,"sources":["webpack://./client/pages/group/GroupPage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,aAAa;AACjB;AACA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,aAAa;IACb,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB","sourcesContent":["#group-page .group-page__header {\n    text-align: center;\n}\n#group-page .group-page__header .group-image {\n    display: block;\n    margin: 0 auto 20px auto;\n    max-width: 200px;\n    height: 200px;\n}\n#group-page .group-page__header .title {\n    font-size: 2em;\n    margin: 0.5em auto;\n}\n#group-page .group-page__header .types {\n    font-size: 1.2em;\n    color: var(--primary-color-dark);\n    margin: 0.5em auto;\n}\n#group-page .group-page__header .types span {\n    display: inline-block;\n    margin: 0 5px;\n}\n#group-page .group-page__header .types svg {\n    width: 1.2em;\n    height: 1.2em;\n    margin-bottom: -0.2em;\n}\n\n#group-page .details {\n    font-size: 16px;\n    max-width: 400px;\n    margin: 0 auto;\n    text-align: center;\n}\n#group-page .details .about {\n    font-size: 14px;\n    padding: 12px;\n    white-space: pre-line;\n    word-wrap: break-word;\n    text-align: left;\n}\n\n#group-page .group-page__controls {\n    text-align: center; \n    margin: 20px auto;\n}\n\n#group-page .group-page__private {\n    margin: 50px auto;\n    text-align: center;\n    font-size: 20px;\n}\n\n#group-page .group-page__main {\n    box-sizing: border-box;\n    padding: 1px; \n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
